import { render, staticRenderFns } from "./arthur-stanley-house-residential-block.vue?vue&type=template&id=55fb8ce8&"
import script from "./arthur-stanley-house-residential-block.vue?vue&type=script&lang=js&"
export * from "./arthur-stanley-house-residential-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports